import React, { useState } from 'react';
import Avatar from '../../submodule/img/01.jpg';
import DialogChatModal from '../Modal/DialogChatModal';
import ProfileModal from '../Modal/ProfileModal';
import dayjs from 'dayjs';

function FeedBackMessage({ onClick, created_at, candidate, clickable = true }) {
  const [chatModalState, setChatModalState] = useState(false);
  const [profileModalState, setProfileModalState] = useState(false);

  return (
    <>
      <li className={`flex w-full mx-atuo customBottomBorder mb-2 p-2 ${clickable ? 'cursor-pointer' : 'cursor-default'}`} onClick={clickable ? onClick : undefined}>
        <div className="flex justify-content">
          <div className="bg-[#E5E5E5] w-[45px] h-[45px]  flex items-center justify-center rounded-md">
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
              <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
            </svg>
          </div>
        </div>
        <div className="flex flex-col text-left text-[#212529] font-bold pl-3">
          <p>{dayjs(created_at).format('HH:mm DD.MM.YYYY')}</p>
          <p>{candidate?.full_name}</p>
        </div>
      </li>

      {/* <ProfileModal open={profileModalState} sendDataToParent={handleDataFromProfileModal} sendDataToParentFromButton={handleDataFromProfileModalButton} />

      <DialogChatModal open={chatModalState} sendDataToParent={handleDataFromChatModal} onCancel={handleCancelChatModal} /> */}
    </>
  );
}

export default FeedBackMessage;
